import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';

import { ControlButtons } from '../ControlButtons';
import { HazmatItem } from './HazmatItem';
import { hazmatInventorySchema } from '../../schemas/hazmatInventorySchema';

export const HazmatInventory = ({
	currInventory = {
		inventory: [
			{
				tradeName: '',
				chemicalName: '',
				physicalState: 'gas',
				quantity: '',
				unit: 'Cubic Feet',
			},
		],
	},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const [inventory, setInventory] = useState(currInventory.inventory);

	const { register, unregister, handleSubmit, formState } = useForm({
		resolver: yupResolver(hazmatInventorySchema),
		defaultValues: currInventory,
	});

	function addNewItem() {
		const newItem = {
			tradeName: '',
			chemicalName: '',
			physicalState: '',
			quantity: '',
			unit: 'Cubic Feet',
		};

		setInventory(previousInventory => [...previousInventory, newItem]);
	}

	const handleRemove = id => {
		setInventory([...inventory.slice(0, id), ...inventory.slice(id + 1)]);
	};

	function commitChange(item, idx) {
		const newInventory = [...inventory];
		newInventory[idx] = item;
		setInventory(newInventory);
	}

	return (
		<Container className="component">
			<Container className="p-0 mt-5 mb-5 component">
				<h2 className="mb-4">Hazmat Inventory</h2>

				{inventory.map((item, id) => (
					<div key={id}>
						<HazmatItem
							id={id}
							currItem={item}
							commitChange={commitChange}
							enableRemove={id === 0 ? false : true}
							handleRemove={handleRemove}
							register={register}
							unregister={unregister}
							error={formState.errors}
						/>
						{inventory.length > 1 && <hr />}
					</div>
				))}

				<Row>
					<Col
						className="mt-2"
						style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button variant="outline-secondary" size="md" onClick={addNewItem}>
							Add Item
						</Button>
					</Col>
				</Row>
			</Container>

			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={onSubmit}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}
			/>
		</Container>
	);
};
